import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";
import { Crown } from "lucide-react";

const FAQS = [
  { q: "What exactly is a Carlocs scalp scan?", a: "It's an expert analysis of a close-up photo of your scalp and loc roots, combined with a short questionnaire. You receive a Crown Score, five category ratings, plain-language observations, product matches, and aftercare tips." },
  { q: "Is this a medical diagnosis?", a: "No. Everything in your report is an observation to guide your loc care routine. It is not a medical diagnosis. For any pain, infection, or hair loss concerns, please consult a qualified professional." },
  { q: "How much does a scan cost?", a: "A single scan fee is R79. Each fee unlocks one complete analysis and report, which is saved to your history." },
  { q: "Who is this built for?", a: "Carlocs Scalp Analyzer is designed exclusively for people with locs — starter, budding, and mature — including microlocs and regular-size locs." },
  { q: "How do I get the best results?", a: "Take a well-lit, close-up photo of your scalp and roots. Answer the questionnaire honestly, especially about wash frequency, products used, and time since your last retwist." },
  { q: "Can I track my progress over time?", a: "Yes. Every scan is saved to your dashboard, where a journey timeline shows your Crown Score and category trends across all past scans." },
];

export default function FAQ() {
  return (
    <div className="min-h-screen bg-charcoal text-cream">
      <Navbar />
      <div className="mx-auto max-w-3xl px-6 py-14">
        <span className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold"><Crown className="h-4 w-4" /> Help Centre</span>
        <h1 className="mt-2 font-heading text-4xl text-cream md:text-5xl">Frequently asked questions</h1>
        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-charcoal-border">
              <AccordionTrigger className="text-left font-heading text-xl text-cream hover:text-gold hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <Footer />
    </div>
  );
}
